import { SummaryColumns } from "@repo/utils";
import { CELL_WIDTHS, WT_ACTIONS_CONTAINER_NAME } from "@utils";
import { makeStyles } from "@material-ui/styles";
import { useEstimateStructure } from "@tools";

export const useSummaryColumnWidthClasses = () => {
  const s = useEstimateStructure();
  
  const priceColSize = s.displaySummaryPriceCellSize || CELL_WIDTHS.VALUE.MEDIUM;
  const rateColSize = s.displaySummaryRateCellSize || CELL_WIDTHS.VALUE.LARGE;
  const costColSize = s.displaySummaryCompanyCostCellSize || CELL_WIDTHS.VALUE.MEDIUM;
  const profitColSize = s.displaySummaryProfitCellSize || CELL_WIDTHS.VALUE.MEDIUM;
  
  return makeStyles(() => ({
    root: {
      [ `--minWidth-${ SummaryColumns.COST }` ]: `${priceColSize}px`,
      [ `--maxWidth-${ SummaryColumns.COST }` ]: `${priceColSize}px`,
      [ `--minWidth-${ SummaryColumns.C_COST }` ]: `${costColSize}px`,
      [ `--maxWidth-${ SummaryColumns.C_COST }` ]: `${costColSize}px`,
      [ `--minWidth-${ SummaryColumns.C_PROFIT }` ]: `${profitColSize}px`,
      [ `--maxWidth-${ SummaryColumns.C_PROFIT }` ]: `${profitColSize}px`,
      [ `--minWidth-${ SummaryColumns.RATE }` ]: `${rateColSize}px`,
      [ `--maxWidth-${ SummaryColumns.RATE }` ]: `${rateColSize}px`,
    }
  }))
}

export const useSectionColumnWidthClasses = (visibleBreakdownColumns, isPrinter) => {
  // const isOnlyCellPinnedLeft = (id) => !visibleBreakdownColumns.find((c) => (
  //   c.pinLeft && c.width && typeof c.pinLeftPx === "number" && c.id !== id
  // ))
  
  // const pinnedColumns = visibleBreakdownColumns
  //   .filter((c) => c.pinLeft || c.pinRight)
  //   .length;

  return makeStyles(() => ({
    root: visibleBreakdownColumns.reduce(( styles, column, index, list ) => {
      if ( !column.pinLeft && !column.pinRight )
        return styles;
      
      const {
        id,
        displayWidth,
        pinLeft,
        pinRight,
        pinLeftPx,
        pinRightPx,
      } = column;
      
      const applyPinLeft = typeof pinLeftPx === "number";
      const applyPinRight = typeof pinRightPx === "number";
      
      const left = applyPinLeft
        ? (pinLeftPx || 0) + (isPrinter ? 0 : CELL_WIDTHS.DRAG_HANDLE)
        : undefined;
      const right = applyPinRight
        ? (pinRightPx || 0) //+ (isPrinter ? 0 :CELL_WIDTHS.VISIBILITY)
        : undefined;
      
      const applyMaxWidth = pinRight || (pinLeft && list[index+1]?.pinLeft && list[index+1]?.isVisible && list[index+1]?.displayWidth);
      
      let minWidth, maxWidth;
      if(displayWidth) {
        minWidth = displayWidth;
        if(applyMaxWidth)
          maxWidth = displayWidth;
      }
      
      if(applyPinLeft && (!list[index+1] || typeof list[index+1].pinLeftPx !== "number")) {
        styles[`--index-${WT_ACTIONS_CONTAINER_NAME}`] = index + 3;
        styles[`--left-${WT_ACTIONS_CONTAINER_NAME}`] = `${left + minWidth - 52}px`;
      }
      
      return {
        ...styles,
        [ `--index-${ id }` ]: column.applyPin ? index + 2 : undefined,
        [ `--left-${ id }` ]: left ? left + "px" : left,
        [ `--right-${ id }` ]: right ? right + "px" : right,
        [ `--minWidth-${ id }` ]: minWidth ? minWidth + "px" : minWidth,
        [ `--maxWidth-${ id }` ]: maxWidth ? maxWidth + "px" : maxWidth,
        // [`& .cell.pinned[data-colindex='${index}']`]: {
        //   left: pinLeftPx + CELL_WIDTHS.DRAG_HANDLE,
        //   minWidth,
        //   maxWidth,
        // }
      }
    }, {  })
  }))
}